import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    document.title = "The ESL Survival Vault™";
    const metaDesc = document.createElement('meta');
    metaDesc.name = "description";
    metaDesc.content = "Get ready-to-use ESL lessons, printable activities and classroom resources designed to help teachers save planning time and teach with confidence.";
    document.head.appendChild(metaDesc);
    const canonical = document.createElement('link');
    canonical.rel = "canonical";
    canonical.href = "https://theeslsurvivalvault.theresourcelab.store/";
    document.head.appendChild(canonical);
    const preloadLCP = document.createElement('link');
    preloadLCP.rel = "preload";
    preloadLCP.as = "image";
    preloadLCP.href = "https://cdn.magicpatterns.com/uploads/dMahrep7F4sfsvQD3fZvZy/mockup_esl_ingles.webp";
    document.head.appendChild(preloadLCP);
    const handleInteraction = () => {
      setLoadDeferredContent(true);
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
    window.addEventListener('scroll', handleInteraction, {
      passive: true
    });
    window.addEventListener('mousemove', handleInteraction, {
      passive: true
    });
    window.addEventListener('touchstart', handleInteraction, {
      passive: true
    });
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 3500);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
      document.head.removeChild(metaDesc);
      document.head.removeChild(canonical);
      document.head.removeChild(preloadLCP);
    };
  }, []);
  return <div className="w-full bg-off-white text-slate" data-id="element-0" data-mp="83qihiiybg7r">
      <MetaPixel data-id="element-1" data-mp="3gmfsn9i3ku7g" />
      <StickyHeader data-id="element-2" data-mp="3glwfs77b0w0a" />
      <main data-id="element-3" data-mp="3gj1ru5p30t24">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="3bmbgfvo82ln1" />
        <Hero data-id="element-5" data-mp="3bnutzeihuil4" />
        <SocialProofBar data-id="element-6" data-mp="3bo4isyrsyjp8" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-off-white" aria-hidden="true" data-id="element-8" data-mp="3qcr0v88tdpk5" />} data-id="element-7" data-mp="3qc96kh5pplev">
            <DeferredLanding data-id="element-9" data-mp="3lk7lq6uhamd8" />
          </Suspense>}
      </main>
    </div>;
}